export default [
  {
    path: '/login',
    name: '登录',
    component: () => import('@/views/user/Login'),
    meta: { breadNumber: 1 }
  },
  {
    path: '/register',
    name: '注册',
    component: () => import('@/views/user/Register'),
    meta: { breadNumber: 1 }
  },
  {
    path: '/user/center',
    name: '用户中心',
    component: () => import('@/views/user/Center'),
    meta: { breadNumber: 1 }
  },
  {
    path: '/user/order',
    name: '我的订单',
    component: () => import('@/views/user/MyOrder'),
    meta: { breadNumber: 2 }

  },
  {
    path: '/user/collect',
    name: '我的收藏',
    component: () => import('@/views/user/MyCollect'),
    meta: { breadNumber: 2 }
  },
  {
    path: '/user/address',
    name: '我的地址',
    component: () => import('@/views/user/MyAddress'),
    meta: { breadNumber: 2 }
  },
  {
    path: '/user/add_address',
    name: '新增地址',
    component: () => import('@/views/user/AddAddress'),
    meta: { breadNumber: 2 }
  },
  {
    path: '/user/memberinfo',
    name: '用户信息',
    component: () => import('@/views/user/Memberinfo'),
    meta: { breadNumber: 2 }
  },
  {
    path: '/user/score/order',
    name: '积分订单',
    component: () => import('@/views/user/ScoreOrder.vue'),
    meta: { breadNumber: 2 }
  }
];
